export default {
    confirm_delete_title:
        '¿Está seguro de que desea eliminar la instancia "{0}"?',
    confirm_delete_body:
        "Después de la eliminación, la acción será irreversible.",
    table: {
        instance_name: "Nombre de la instancia",
        connected: "Conectada",
        linked_users: "Usuarios vinculados",
        linked_branches: "Sucursales vinculadas",
        qr_code: "Código QR",
        delete_instance: "Eliminar instancia",
    },
    status: {
        connected: "Sí - {0}",
        disconnected: "No",
        replacing: "Reemplazando...",
        loading: "Cargando...",
        connected_already: "Ya conectado",
    },
    buttons: {
        replace_error: "Error, reemplazar instancia",
        generate: "Generar",
        disconnect: "Desconectar",
        delete: "Eliminar",
        add: "Agregar instancia",
    },
    form: {
        placeholder_name: "Nombre de la instancia",
    },
    notifications: {
        created: "Nueva instancia creada",
        replaced: "Instancia reemplazada",
        replace_error: "Error al reemplazar la instancia",
        disconnected: "Instancia desconectada",
        disconnect_error: "Error al desconectar la instancia",
        deleted: "Instancia eliminada",
        server_error: "Error interno del servidor, intente de nuevo más tarde.",
    },
};
